import common from './common'
import user from './user'
import myAccount from './my-account'
import bankCard from './bank-card'
import { download, detail, exportExcelData, monthlyReportExport, purchaseSaleListExport, billExport } from './export'
import spotPurchaseSaleInquiry from './spot-purchase-sale-inquiry'
import othersInquiry from './others-inquiry'
import productLineReport from './product-line-report'
import myStore from './my-store'
import transationManage from './transationManage'
import contract from './contract'

export default {
  common,
  user,
  myAccount,
  bankCard,
  spotPurchaseSaleInquiry,
  download, // 现货购销-报表导出统一接口
  detail, // 现货购销-报表详情统一导出接口
  monthlyReportExport, // 月报表导出
  exportExcelData,
  purchaseSaleListExport, // 购销计划一览表导出
  othersInquiry, // 其他查询
  productLineReport, // 产品线报表
  billExport, // 交易流水下载
  myStore, // 我的店铺
  transationManage, // 交易管理
  contract, // 合同
}
